<template>
  <div
    class="fill-height">
    <v-layout wrap>
      <v-dialog v-model="dialog.warning"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_warning.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Realisasi keuangan (SP2D) yang diinputkan
                
                  belum sesuai dengan data SP2D (BPKPAD) <span v-if="this.$store.state.user.role === 'opd' ? (this.$store.state.user.unit_id === '26' || this.$store.state.user.unit_id === '22' || this.$store.state.user.unit_id === '6' || this.$store.state.user.unit_id === '4' || this.$store.state.user.unit_type === 'Puskesmas') ? true : false : (this.filter.unit_id === '26' || this.filter.unit_id === '22' || this.filter.unit_id === '4' || this.filter.unit_id === '6' || this.filter.unit_type === 'Puskesmas')">dan SP2B</span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      <v-flex>
        <section>
          <v-row
            class="px-2">
            <v-col 
              cols="12">
              <v-row>
                <v-col 
                  cols="12" class="py-0">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-card-text
                      class="d-flex align-center">
                      <v-avatar
                        tile
                        size="40">
                        <v-img 
                          alt="amanata" 
                          :src="require('@/assets/icon/statistik.png')"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="white">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>

                      <div
                        class="ml-4 mb-1">
                        <div
                          class="fs-15 black--text"
                          style="font-weight: 600;">
                          Data Statistik
                        </div>

                        <div
                          class="fs-13">
                          Periode Tahun {{ filter.year }} Bulan {{ filter.month_text}}
                        </div>
                      </div>

                      <v-spacer />

                      <div
                        class="d-flex align-center">
                        <div v-if="user.role === 'admin'">
                          <!-- <div class="body-2 mb-2">
                            Pilih Filter
                          </div> -->

                          <!-- <v-autocomplete
                            filled
                            rounded
                            dense

                            :color="set_color"
                            placeholder="Pilih Filter"

                            :items="type"
                            :item-color="set_color"

                            hide-details

                            clearable
                            @click:clear="filter.type = ''"

                            v-model="filter.type"
                            required
                            style="border-radius: 10px; width: 180px;">
                          </v-autocomplete> -->
                        </div>
                        <div v-if="user.role === 'admin'">
                          <div>

                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Pilih Filter"

                              :items="category"
                              :item-color="set_color"
                              hide-details
                              v-on:change="filter.unit_id = ''; filter.asistensi = ''; filter.type = '';"


                              clearable
                              @click:clear="filter.category = ''"

                              v-model="filter.category"
                              required
                              class="mx-1"
                              style="border-radius: 10px; width: 200px;">
                            </v-autocomplete>
                          </div>
                        </div>
                        <div v-if="user.role === 'admin'">

                          <div v-if="filter.category === 'Gabungan'">
                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Pilih Filter Gabungan"

                              :items="type"
                              :item-color="set_color"
                              hide-details

                              clearable
                              @click:clear="filter.type = ''"

                              v-model="filter.type"
                              required
                              class="mx-1"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </div>
                        </div>
                        <div v-if="user.role === 'admin'">

                          <div v-if="filter.type === 'Asisten'">
                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Asisten Administrasi Umum"

                              :items="asistensi"
                              :item-color="set_color"
                              hide-details

                              clearable
                              @click:clear="filter.asistensi = ''"

                              v-model="filter.asistensi"
                              required
                              class="mx-1"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </div>
                        </div>
                        <div v-if="user.role === 'admin'">

                          <div v-if="filter.category === 'OPD'">
                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Bagian Administrasi Pembangunan"

                              :items="unit"
                              item-text="title"
                              item-value="id"
                              :item-color="set_color"
                              hide-details

                              clearable
                              @click:clear="filter.unit_id = ''"

                              v-model="filter.unit_id"
                              class="mx-1"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </div>
                        </div>
                        <div v-if="user.role === 'admin'">

                          <div v-if="filter.type === 'Kecamatan'">

                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Kecamatan Klaten tengah"

                              :items="filter_data.kecamatan"
                              item-text="name"
                              item-value="id"
                              :item-color="set_color"

                              hide-details

                              clearable
                              @click:clear="filter.kecamatan_id = ''"

                              v-model="filter.kecamatan_id"
                              required
                              class="mx-1"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </div>
                        </div>

                        <v-select
                          filled
                          rounded
                          dense
                          hide-details
                          :color="set_color"
                          placeholder="Pengecualian"

                          :items="[
                            { text: 'Dengan Pengecualian', value: '1' },
                            { text: 'Tanpa Pengecualian', value: '0' }
                          ]"
                          item-text="text"
                          item-value="value"
                          :item-color="set_color"

                          v-model="filter.is_pengecualian"
                          style="border-radius: 10px; width: 250px;">
                        </v-select>

                        <!-- <div v-if="user.role === 'admin' && (new Date(filter.year, filter.month - 1, 1) < new Date(new Date(dpa.perubahan_date).getFullYear(), new Date(dpa.perubahan_date).getMonth(), 1))">
                          <div>
                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Status Anggaran"

                              :items="['murni', 'p1']"
                              :item-color="set_color"
                              hide-details


                              clearable
                              @click:clear="filter.dpa = ''"

                              v-model="filter.dpa"
                              required
                              class="mx-1"
                              style="border-radius: 10px; width: 200px;">
                            </v-autocomplete>
                          </div>
                        </div> -->

                        <v-select
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Pilih Bulan"

                          hide-details
                          class="mx-1"

                          :items="bulan"
                          :item-color="set_color"

                          v-model="filter.month"
                          style="border-radius: 10px; width: 180px;">
                        </v-select>


                        <v-select
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Pilih Tahun"

                          hide-details

                          :items="years"
                          :item-color="set_color"

                          v-model="filter.year"
                          style="border-radius: 10px; width: 120px;">
                        </v-select>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row 
                justify="center">
                <v-col cols="12" md="3">
                  <v-card
                    class="border-radius stat-card"
                    color="#FFFFFF"
                    height="100%"
                    style="height: -webkit-fill-available">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="fs-15 black--text card-title-enhanced"
                              style="margin-bottom: 3px;">
                              Pagu Anggaran
                            </div>

                            <div
                              class="fs-12 card-subtitle-enhanced">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div class="icon-container">
                            <v-img 
                              width="40"
                              height="40"
                              contain
                              alt="amanata" 
                              :src="require('@/assets/icon/budget.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="pt-0">
                        <div
                          class="boder-margin-4">
                          <div class="d-flex align-center mb-1">
                            <div class="period-label murni" style="font-weight: 500; color: #1976D2;">
                              Murni
                            </div>
                            <v-spacer />
                            <v-chip
                              x-small
                              color="blue"
                              text-color="white"
                              class="period-badge">
                              {{ getMurniInfo() }}
                            </v-chip>
                          </div>

                          <div
                            class="fs-18 black--text value-display number-display"
                            style="font-weight: 500;">
                            <span v-if="getMurniValue('pagu_anggaran') === '-'" class="empty-state">
                              -
                            </span>
                            <span v-else>
                              {{ getMurniValue('pagu_anggaran') | price }}
                            </span>
                          </div>
                        </div>

                        <div class="boder-margin-4">
                          <div class="d-flex align-center mb-1">
                            <div class="period-label p1" style="font-weight: 500; color: #FF9800;">
                              P1
                            </div>
                            <v-spacer />
                            <v-chip
                              x-small
                              color="orange"
                              text-color="white"
                              class="period-badge">
                              {{ getP1Info() }}
                            </v-chip>
                          </div>

                          <div
                            class="fs-18 black--text value-display number-display"
                            style="font-weight: 500;">
                            <span v-if="getP1Value('pagu_anggaran_p1') === '-'" class="empty-state">
                              -
                            </span>
                            <span v-else>
                              {{ getP1Value('pagu_anggaran_p1') | price }}
                            </span>
                          </div>
                        </div>

                        <div>
                          <div class="d-flex align-center mb-1 pt-4">
                            <div class="period-label perubahan" style="font-weight: 500; color: #4CAF50;">
                              Perubahan
                            </div>
                            <v-spacer />
                            <v-chip
                              x-small
                              color="green"
                              text-color="white"
                              class="period-badge">
                              {{ getPerubahanInfo() }}
                            </v-chip>
                          </div>

                          <div
                            class="fs-18 black--text value-display number-display"
                            style="font-weight: 500;">
                            <span v-if="getPerubahanValue('pagu_anggaran_perubahan') === '-'" class="empty-state">
                              -
                            </span>
                            <span v-else>
                              {{ getPerubahanValue('pagu_anggaran_perubahan') | price }}
                            </span>
                          </div>
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <v-col cols="12" md="3" class="pl-0">
                  <v-card
                    class="border-radius stat-card"
                    color="#FFFFFF"
                    style="height: -webkit-fill-available">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="fs-15 black--text card-title-enhanced"
                              style="margin-bottom: 3px;">
                              Anggaran Kas 
                            </div>

                            <div
                              class="fs-13"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div class="icon-container">
                            <v-img 
                              width="40"
                              height="40"
                              alt="amanata" 
                              contain
                              :src="require('@/assets/icon/percent.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="pt-0">
                        <div
                          class="boder-margin-4">
                          <div class="d-flex align-center mb-1">
                            <div class="period-label murni" style="font-weight: 500; color: #1976D2;">
                              Murni
                            </div>
                            <v-spacer />
                            <v-chip
                              x-small
                              color="blue"
                              text-color="white"
                              class="period-badge">
                              {{ getMurniInfo() }}
                            </v-chip>
                          </div>
                          
                          <div
                            class="fs-18 black--text value-display number-display"
                            style="font-weight: 500;">
                            <span v-if="getMurniValue('target_keuangan') === '-'">
                              -
                            </span>
                            <span v-else>
                              {{ getMurniValue('target_keuangan') | price }}
                            </span>
                          </div>
                        </div>

                        <div class="boder-margin-4">
                          <div class="d-flex align-center mb-1">
                            <div class="period-label p1" style="font-weight: 500; color: #FF9800;">
                              P1
                            </div>
                            <v-spacer />
                            <v-chip
                              x-small
                              color="orange"
                              text-color="white"
                              class="period-badge">
                              {{ getP1Info() }}
                            </v-chip>
                          </div>

                          <div
                            class="fs-18 black--text value-display number-display"
                            style="font-weight: 500;">
                            <span v-if="getP1Value('target_keuangan') === '-'">
                              -
                            </span>
                            <span v-else>
                              {{ getP1Value('target_keuangan') | price }}
                            </span>
                          </div>
                        </div>

                        <div>
                          <div class="d-flex align-center mb-1 pt-4">
                            <div class="period-label perubahan" style="font-weight: 500; color: #4CAF50;">
                              Perubahan
                            </div>
                            <v-spacer />
                            <v-chip
                              x-small
                              color="green"
                              text-color="white"
                              class="period-badge">
                              {{ getPerubahanInfo() }}
                            </v-chip>
                          </div>

                          <div
                            class="fs-18 black--text value-display number-display"
                            style="font-weight: 500;">
                            <span v-if="getPerubahanValue('target_keuangan') === '-'">
                              -
                            </span>
                            <span v-else>
                              {{ getPerubahanValue('target_keuangan') | price }}
                            </span>
                          </div>
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <v-col 
                  cols="12" 
                  md="6"
                  class="pl-0">
                  <v-card
                    class="border-radius stat-card"
                    color="#FFFFFF"
                    style="height: -webkit-fill-available">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="fs-15 black--text card-title-enhanced"
                              style="margin-bottom: 3px;">
                              Perkembangan Fisik 
                            </div>

                            <div
                              class="fs-13"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div class="icon-container">
                            <v-img 
                              width="40"
                              height="40"
                              contain
                              alt="amanata" 
                              :src="require('@/assets/icon/dash_kegiatan.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="py-0">
                        <v-row class="mx-0">
                          <v-col cols="12" sm="4" class="px-1">
                            <div style="font-size: 17px; font-weight: 600;" class="mb-3">
                              Target
                            </div>

                            <div>
                              <div
                                class="period-row">
                                <div class="period-label murni" style="font-weight: 500; color: #1976D2;">
                                  Murni
                                </div>
                                <div 
                                  class="caption"
                                  style="opacity: 0.7; font-size: 11px; margin-bottom: 10px; line-height: 1.3;">
                                  {{ getMurniInfo() }}
                                </div>
                                
                                <div
                                  class="fs-18 black--text value-display"
                                  style="font-weight: 600; font-size: 20px;">
                                  <span v-if="getMurniValue('target_fisik') === '-'">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ getMurniValue('target_fisik') === null ? 0 : getMurniValue('target_fisik') }}
                                  </span>
                                </div>
                              </div>

                              <div class="period-row">
                                <div class="period-label p1" style="font-weight: 500; color: #FF9800;">
                                  P1
                                </div>
                                <div 
                                  class="caption"
                                  style="opacity: 0.7; font-size: 11px; margin-bottom: 10px; line-height: 1.3;">
                                  {{ getP1Info() }}
                                </div>

                                <div
                                  class="fs-18 black--text value-display"
                                  style="font-weight: 600; font-size: 20px;">
                                  <span v-if="getP1Value('target_fisik') === '-'">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ getP1Value('target_fisik') === null ? 0 : getP1Value('target_fisik') }}
                                  </span>
                                </div>
                              </div>
      
                              <div class="period-row">
                                <div class="period-label perubahan" style="font-weight: 500; color: #4CAF50;">
                                  Perubahan
                                </div>
                                <div 
                                  class="caption"
                                  style="opacity: 0.7; font-size: 11px; margin-bottom: 10px; line-height: 1.3;">
                                  {{ getPerubahanInfo() }}
                                </div>
                                <div
                                  class="fs-18 black--text value-display"
                                  style="font-weight: 600; font-size: 20px;">
                                  <span v-if="getPerubahanValue('target_fisik') === '-'">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ getPerubahanValue('target_fisik') === null ? 0 : getPerubahanValue('target_fisik') }}
                                  </span>
                                </div>
                              </div>

                            </div>
                          </v-col>

                          <v-col cols="12" sm="4" class="px-3">
                            <div style="font-size: 17px; font-weight: 600;" class="mb-3">
                              Realisasi
                            </div>

                            <div>
                              <div
                                class="period-row">
                                <div class="period-label murni" style="font-weight: 500; color: #1976D2;">
                                  Murni
                                </div>
                                <div 
                                  class="caption"
                                  style="opacity: 0.7; font-size: 11px; margin-bottom: 10px; line-height: 1.3;">
                                  {{ getMurniInfo() }}
                                </div>
                                
                                <div
                                  class="fs-18 black--text value-display"
                                  style="font-weight: 600; font-size: 20px;">
                                  <span v-if="getMurniValue('realisasi_fisik') === '-'">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ getMurniValue('realisasi_fisik') === null ? 0 : getMurniValue('realisasi_fisik') }}
                                  </span>
                                </div>
                              </div>
      
                              <div class="period-row">
                                <div class="period-label p1" style="font-weight: 500; color: #FF9800;">
                                  P1
                                </div>
                                <div 
                                  class="caption"
                                  style="opacity: 0.7; font-size: 11px; margin-bottom: 10px; line-height: 1.3;">
                                  {{ getP1Info() }}
                                </div>

                                <div
                                  class="fs-18 black--text value-display"
                                  style="font-weight: 600; font-size: 20px;">
                                  <span v-if="getP1Value('realisasi_fisik') === '-'">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ getP1Value('realisasi_fisik') === null ? 0 : getP1Value('realisasi_fisik') }}
                                  </span>
                                </div>
                              </div>

                              <div class="period-row">
                                <div class="period-label perubahan" style="font-weight: 500; color: #4CAF50;">
                                  Perubahan
                                </div>
                                <div 
                                  class="caption"
                                  style="opacity: 0.7; font-size: 11px; margin-bottom: 10px; line-height: 1.3;">
                                  {{ getPerubahanInfo() }}
                                </div>
                                <div
                                  class="fs-18 black--text value-display"
                                  style="font-weight: 600; font-size: 20px;">
                                  <span v-if="getPerubahanValue('realisasi_fisik') === '-'">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ getPerubahanValue('realisasi_fisik') === null ? 0 : getPerubahanValue('realisasi_fisik') }}
                                  </span>
                                </div>
                              </div>

                            </div>
                          </v-col>

                          <v-col cols="12" sm="4" class="px-3">
                            <div style="font-size: 17px; font-weight: 600;" class="mb-3">
                              Deviasi
                            </div>

                            <div>
                              <div
                                class="period-row">
                                <div class="period-label murni" style="font-weight: 500; color: #1976D2;">
                                  Murni
                                </div>
                                <div 
                                  class="caption"
                                  style="opacity: 0.7; font-size: 11px; margin-bottom: 10px; line-height: 1.3;">
                                  {{ getMurniInfo() }}
                                </div>
                                
                                <div
                                  class="fs-18 black--text value-display"
                                  style="font-weight: 600; font-size: 20px;">
                                  <span v-if="getMurniValue('deviasi_fisik') === '-'">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ getMurniValue('deviasi_fisik') === null ? 0 : getMurniValue('deviasi_fisik') }}
                                  </span>
                                </div>
                              </div>

                              <div class="period-row">
                                <div class="period-label p1" style="font-weight: 500; color: #FF9800;">
                                  P1
                                </div>
                                <div 
                                  class="caption"
                                  style="opacity: 0.7; font-size: 11px; margin-bottom: 10px; line-height: 1.3;">
                                  {{ getP1Info() }}
                                </div>

                                <div
                                  class="fs-18 black--text value-display"
                                  style="font-weight: 600; font-size: 20px;">
                                  <span v-if="getP1Value('deviasi_fisik') === '-'">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ getP1Value('deviasi_fisik') === null ? 0 : getP1Value('deviasi_fisik') }}
                                  </span>
                                </div>
                              </div>
      
                              <div class="period-row">
                                <div class="period-label perubahan" style="font-weight: 500; color: #4CAF50;">
                                  Perubahan
                                </div>
                                <div 
                                  class="caption"
                                  style="opacity: 0.7; font-size: 11px; margin-bottom: 10px; line-height: 1.3;">
                                  {{ getPerubahanInfo() }}
                                </div>
                                <div
                                  class="fs-18 black--text value-display"
                                  style="font-weight: 600; font-size: 20px;">
                                  <span v-if="getPerubahanValue('deviasi_fisik') === '-'">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ getPerubahanValue('deviasi_fisik') === null ? 0 : getPerubahanValue('deviasi_fisik') }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col 
                  cols="12" 
                  :md="6" class="py-0">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-card-text class="pb-0">
                      <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="fs-15 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Realisasi Keuangan
                            </div>

                            <div
                              class="fs-13"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div class="icon-container">
                            <v-img 
                              width="40"
                              height="40"
                              contain
                              alt="amanata" 
                              :src="require('@/assets/icon/comparison.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                    </v-card-text>
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="article, list-item-three-line, article, list-item-three-line">


                      <!-- <v-divider class="mx-3 my-3"></v-divider> -->
                      <div class="pa-3">
                        <table style="width: 100%;">
                          <tr>
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Nama
                            </td>
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Nominal 
                            </td>
                            <!-- <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Nominal (Perubahan)
                            </td> -->
                          </tr>
                          <tr v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 500;">
                              Data Keuangan/SP2D (BPKPAD)
                            </td>
                            <td class="pa-2 body-1 black--text" style="border: 1px solid #ededed; font-weight: 500;">
                              {{ getSp2dBulan() | price }}
                            </td>
                          </tr>
                          <tr v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 500;">
                              Data Keuangan/SP2B
                            </td>
                            <td class="pa-2 body-1 black--text" style="border: 1px solid #ededed; font-weight: 500;">
                              {{ getSp2bBulan() | price }}
                            </td>
                          </tr>
                          <tr v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600; width: 300px;">
                              Total SP2B & SP2D 
                            </td>
                            <td class="pa-2 body-1 font-weight-bold  black--text" style="border: 1px solid #ededed; font-weight: 500;">
                              {{ getTotalSp2bSp2d() | price }}
                            </td>
                          </tr>
                          <tr>
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Realisasi Keuangan (OPD)
                            </td>
                            <td class="pa-2 font-weight-bold body-1 black--text" style="border: 1px solid #ededed;">
                              {{ getRealisasiKeuangan() | price }}
                            </td>
                          </tr>
                          <tr :style="getSelisihRealisasi() === 0 ? '' : 'background: #FFCDD2;'" v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Selisih
                            </td>
                            <td class="pa-2 font-weight-bold body-1 black--text" style="border: 1px solid #ededed;">
                              {{ getSelisihRealisasi() | price }}
                            </td>
                          </tr>
                        </table>
                      </div>

                      <!-- <v-divider class="mx-3"></v-divider>
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div style="width: calc(100% / 3)">
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Realisasi Keuangan/SP2D (OPD)
                            </div>
      
                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                          
      
                          <v-spacer />
                          <div v-if="this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false" style="width: calc(100% / 3)">
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Data Keuangan/SP2D (BPKPAD)
                            </div>
      
                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />
                          <div v-if="this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false" style="width: calc(100% / 3)">
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Data Keuangan/SP2B
                            </div>
      
                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                      <v-card-text
                        class="pt-0">
                        <div
                          class="d-flex align-start">
                          <div style="width: calc(100% / 3)">
                            <div
                              class="boder-margin-4">
                              <div>
                                Murni
                              </div>
                              
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                <span v-if="detail.realisasi_keuangan === null">
                                  0
                                </span>
                                <span v-else>
                                  {{ detail.realisasi_keuangan | price }}
                                </span>
                              </div>
                            </div>
          
                            <div>
                              <div>
                                Perubahan
                              </div>
  
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                0
                              </div>
                            </div>
                          </div>

                          <v-spacer />

                          <div style="width: calc(100% / 3)" v-if="this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <div
                              class="boder-margin-4">
                              <div>
                                Nominal
                              </div>
                              
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                <span v-if="detail.sp2d_bulan === null">
                                  0
                                </span>
                                <span v-else>
                                  {{ detail.sp2d_bulan | price }}
                                </span>
                              </div>
                            </div>
                          </div>

                          <v-spacer />

                          <div style="width: calc(100% / 3)" v-if="this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <div
                              class="boder-margin-4">
                              <div>
                                Nominal
                              </div>
                              
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                <span v-if="detail.sp2b_bulan === null">
                                  0
                                </span>
                                <span v-else>
                                  {{ detail.sp2b_bulan | price }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card-text> -->
                      <!-- <div>
                        <v-divider class="mx-3"></v-divider>

                      </div> -->
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <v-col 
                  cols="12" 
                  :md="3" class="py-0 px-0">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="article, list-item-three-line">
                      <v-card-text class="pb-0">
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="fs-15 black--text card-title-enhanced"
                              style="margin-bottom: 3px;">
                              Persentase Realisasi Keuangan Terhadap Pagu Anggaran 
                            </div>

                            <div
                              class="fs-13"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="mt-9">
                        <div
                          class="text-h5 black--text"
                          style="font-weight: 500;"
                          :style="this.$store.state.user.role === 'opd' ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : this.filter.unit_id !== '' && this.filter.unit_id !== null ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : ''">
                          {{ getPersentasePaguAnggaran() }}
                          <!-- {{ parseFloat(getPersentasePaguAnggaran()*100).toFixed(2) }} -->
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
                <v-col 
                  cols="12" 
                  :md="3" class="py-0">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="article, list-item-three-line">
                      <v-card-text class="pb-0">
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="fs-15 black--text card-title-enhanced"
                              style="margin-bottom: 3px;">
                              Persentase Realisasi Keuangan Terhadap Anggaran Kas
                            </div>

                            <div
                              class="fs-13"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="mt-9">
                        <div
                          class="text-h5 black--text"
                          style="font-weight: 500;"
                          :style="this.$store.state.user.role === 'opd' ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : this.filter.unit_id !== '' && this.filter.unit_id !== null ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : ''">
                          <!-- {{ getPersentaseAnggaranKas() === null ? 0 : parseFloat(getPersentaseAnggaranKas()*100).toFixed(2) }} -->
                          {{ getPersentaseAnggaranKas() }}
                        </div>

                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <!-- <v-col cols="12" v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-card-text>
                      <div class="body-2">
                        Perbandingan Realisasi Keuangan/SP2D dengan Total SP2B & SP2D
                      </div>
                      <v-divider class="mx-3 my-3"></v-divider>
                      <table>
                        <tr>
                          <td class="pl-2 py-1 pr-5">
                            Realisasi Keuangan/SP2D
                          </td>
                          <td class="pa-2 font-weight-bold body-1 black--text">
                            : {{ detail.realisasi_keuangan === null ? 0 : detail.realisasi_keuangan | price }}
                          </td>
                        </tr>
                        <tr>
                          <td class="pl-2 py-1 pr-5">
                            Total SP2B & SP2D 
                          </td>
                          <td class="pa-2 font-weight-bold body-1 black--text">
                            : {{ ((detail.sp2b_bulan*1)+(detail.sp2d_bulan*1))| price }}
                          </td>
                        </tr>
                        <tr>
                          <td class="pl-2 py-1 pr-5">
                            Selisih
                          </td>
                          <td class="pa-2 font-weight-bold body-1 black--text">
                            : {{( (detail.realisasi_keuangan*1)-((detail.sp2b_bulan*1)+(detail.sp2d_bulan*1)))| price }}
                          </td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
                </v-col> -->
              </v-row>


              <v-row 
                justify="center">
                <v-col 
                  cols="12" 
                  md="6">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="fs-15 black--text card-title-enhanced"
                              style="margin-bottom: 3px;">
                              Pengelompokan Prosentase Pelaksanaan Sub Kegiatan 
                            </div>

                            <div
                              class="fs-13"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div class="icon-container">
                            <v-img 
                              width="40"
                              height="40"
                              alt="amanata" 
                              contain
                              :src="require('@/assets/icon/total_persentase_sp2d_anggaran.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="pt-0">
                        <table style="width: 100%;" v-if="Object.keys(list.realisasi).length > 0" class="border-radius mt-5">
                          <tr>
                            <th style="border: 1px solid #ededed; padding: 8px;">Persentase</th>
                            <th style="border: 1px solid #ededed; padding: 8px;">Jumlah</th>
                          </tr>

                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: #ff0000d9">
                              0%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: #ff0000d9; font-weight: bold">
                              {{ list.realisasi.a | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: orange;">
                              1% - 25%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: orange; font-weight: bold">
                              {{ list.realisasi.b | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: yellow;">
                              26% - 50%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: yellow; font-weight: bold">
                              {{ list.realisasi.c | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: green; color: white;">
                              51% - 75%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: green; color: white; font-weight: bold">
                              {{ list.realisasi.d | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: blue">
                              76% - 99%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: blue; font-weight: bold">
                              {{ list.realisasi.e | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px;">
                              100%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; font-weight: bold">
                              {{ list.realisasi.f | number }}
                            </td>
                          </tr>
                        </table>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
                
                <v-col 
                  cols="12" 
                  md="6" class="pl-0">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="fs-15 black--text card-title-enhanced"
                              style="margin-bottom: 3px;">
                              Pengelompokan Deviasi Fisik Sub Kegiatan 
                            </div>

                            <div
                              class="fs-13"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div class="icon-container">
                            <v-img 
                              width="40"
                              height="40"
                              contain
                              alt="amanata" 
                              :src="require('@/assets/icon/analytics.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="pt-0">
                        <table style="width: 100%;" class="border-radius mt-5" v-if="Object.keys(list.deviasi).length > 0">
                          <tr>
                            <th style="border: 1px solid #ededed; padding: 8px;">Nilai</th>
                            <th style="border: 1px solid #ededed; padding: 8px;">Jumlah</th>
                          </tr>

                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: #ff0000d9">
                              -100 s/d -10
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: #ff0000d9; font-weight: bold">
                              {{ list.deviasi.a | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: orange;">
                              -9.99 s/d -6.00
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: orange; font-weight: bold">
                              {{ list.deviasi.b | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: yellow;">
                              -5.99 s/d -3.00
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: yellow; font-weight: bold">
                              {{ list.deviasi.c | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: green; color: white;">
                              -2.99 s/d 9.99
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: green; color: white; font-weight: bold">
                              {{ list.deviasi.d | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: blue">
                              Lebih dari 10
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: blue; font-weight: bold">
                              {{ list.deviasi.e | number }}
                            </td>
                          </tr>
                        </table>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col 
                  cols="12" 
                  md="12"
                  class="py-0">
                  <v-card
                    class="border-radius boder-margin-4"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-center">
                          <div>
                            <div 
                              class="fs-15 black--text card-title-enhanced"
                              style="margin-bottom: 3px;">
                              Program, Kegiatan & Sub kegiatan 
                            </div>

                            <div
                              class="fs-13"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div class="icon-container">
                            <v-img 
                              width="40"
                              height="40"
                              alt="amanata" 
                              :src="require('@/assets/icon/pengadaan.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                    <div class="px-3 pb-4">
                      <v-row>
                        <v-col>
                          <v-card
                            class="border-radius"
                            color="#FFFFFF"
                            style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                            <v-skeleton-loader
                              class="ma-auto"
                              :loading="process.load"
                              type="image">
                              <v-card-text>
                                <div
                                  class="d-flex align-start">
                                  <div>
                                    <div 
                                      class="fs-15 black--text card-title-enhanced"
                                      style="margin-bottom: 3px;">
                                      Program 
                                    </div>
    
                                    <div
                                      class="fs-13"
                                      style="opacity: 70%;">
                                      Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                                    </div>
                                  </div>
    
                                  <v-spacer />
    
                                  
                                </div>
                              </v-card-text>
    
                              <v-card-text
                                class="pt-0">
                                <div
                                  class="boder-margin-4">
                                  <div class="d-flex align-center mb-1">
                                    <div style="font-weight: 500; color: #1976D2;">
                                      Murni
                                    </div>
                                    <v-spacer />
                                    <v-chip
                                      x-small
                                      color="blue"
                                      text-color="white"
                                      style="font-size: 9px; height: 18px;">
                                      {{ getMurniInfo() }}
                                    </v-chip>
                                  </div>
    
                                  <div
                                    class="text-h5 black--text"
                                    style="font-weight: 500;">
                                    <span v-if="getTotalProgram('murni') === '-'">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ getTotalProgram('murni') | number }}
                                    </span>
                                  </div>
                                </div>
    
                                <div class="boder-margin-4">
                                  <div class="d-flex align-center mb-1">
                                    <div style="font-weight: 500; color: #FF9800;">
                                      P1
                                    </div>
                                    <v-spacer />
                                    <v-chip
                                      x-small
                                      color="orange"
                                      text-color="white"
                                      style="font-size: 9px; height: 18px;">
                                      {{ getP1Info() }}
                                    </v-chip>
                                  </div>
    
                                  <div
                                    class="text-h5 black--text"
                                    style="font-weight: 500;">
                                    <span v-if="getTotalProgram('p1') === '-'">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ getTotalProgram('p1') | number }}
                                    </span>
                                  </div>
                                </div>
    
                                <div>
                                  <div class="d-flex align-center mb-1">
                                    <div style="font-weight: 500; color: #4CAF50;">
                                      Perubahan
                                    </div>
                                    <v-spacer />
                                    <v-chip
                                      x-small
                                      color="green"
                                      text-color="white"
                                      style="font-size: 9px; height: 18px;">
                                      {{ getPerubahanInfo() }}
                                    </v-chip>
                                  </div>
    
                                  <div
                                    class="text-h5 black--text"
                                    style="font-weight: 500;">
                                    <span v-if="getTotalProgram('perubahan') === '-'">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ getTotalProgram('perubahan') | number }}
                                    </span>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-skeleton-loader>
                          </v-card>
                        </v-col>
    
                        <v-col>
                          <v-card
                            class="border-radius"
                            color="#FFFFFF"
                            style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                            <v-skeleton-loader
                              class="ma-auto"
                              :loading="process.load"
                              type="image">
                              <v-card-text>
                                <div
                                  class="d-flex align-start">
                                  <div>
                                    <div 
                                      class="body-1 black--text card-title-enhanced"
                                      style="margin-bottom: 3px;">
                                      Kegiatan 
                                    </div>
    
                                    <div
                                      class="body-2"
                                      style="opacity: 70%;">
                                      Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                                    </div>
                                  </div>
    
                                  <v-spacer />
                                  
                                </div>
                              </v-card-text>
    
                              <v-card-text
                                class="pt-0">
                                <div
                                  class="boder-margin-4">
                                  <div class="d-flex align-center mb-1">
                                    <div style="font-weight: 500; color: #1976D2;">
                                      Murni
                                    </div>
                                    <v-spacer />
                                    <v-chip
                                      x-small
                                      color="blue"
                                      text-color="white"
                                      style="font-size: 9px; height: 18px;">
                                      {{ getMurniInfo() }}
                                    </v-chip>
                                  </div>
                                  
                                  <div
                                    class="text-h5 black--text"
                                    style="font-weight: 500;">
                                    <span v-if="getTotalKegiatan('murni') === '-'">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ getTotalKegiatan('murni') | number }}
                                    </span>
                                  </div>
                                </div>
    
                                <div class="boder-margin-4">
                                  <div class="d-flex align-center mb-1">
                                    <div style="font-weight: 500; color: #FF9800;">
                                      P1
                                    </div>
                                    <v-spacer />
                                    <v-chip
                                      x-small
                                      color="orange"
                                      text-color="white"
                                      style="font-size: 9px; height: 18px;">
                                      {{ getP1Info() }}
                                    </v-chip>
                                  </div>
                                  <div
                                    class="text-h5 black--text"
                                    style="font-weight: 500;">
                                    <span v-if="getTotalKegiatan('p1') === '-'">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ getTotalKegiatan('p1') | number }}
                                    </span>
                                  </div>
                                </div>
    
                                <div>
                                  <div class="d-flex align-center mb-1">
                                    <div style="font-weight: 500; color: #4CAF50;">
                                      Perubahan
                                    </div>
                                    <v-spacer />
                                    <v-chip
                                      x-small
                                      color="green"
                                      text-color="white"
                                      style="font-size: 9px; height: 18px;">
                                      {{ getPerubahanInfo() }}
                                    </v-chip>
                                  </div>
                                  <div
                                    class="text-h5 black--text"
                                    style="font-weight: 500;">
                                    <span v-if="getTotalKegiatan('perubahan') === '-'">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ getTotalKegiatan('perubahan') | number }}
                                    </span>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-skeleton-loader>
                          </v-card>
                        </v-col>
    
                        <v-col>
                          <v-card
                            class="border-radius"
                            color="#FFFFFF"
                            style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                            <v-skeleton-loader
                              class="ma-auto"
                              :loading="process.load"
                              type="image">
                              <v-card-text>
                                <div
                                  class="d-flex align-start">
                                  <div>
                                    <div 
                                      class="body-1 black--text card-title-enhanced"
                                      style="margin-bottom: 3px;">
                                      Sub kegiatan 
                                    </div>
    
                                    <div
                                      class="body-2"
                                      style="opacity: 70%;">
                                      Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                                    </div>
                                  </div>
    
                                  <v-spacer />
                                  
                                </div>
                              </v-card-text>
    
                              <v-card-text
                                class="pt-0">
                                <div
                                  class="boder-margin-4">
                                  <div class="d-flex align-center mb-1">
                                    <div style="font-weight: 500; color: #1976D2;">
                                      Murni
                                    </div>
                                    <v-spacer />
                                    <v-chip
                                      x-small
                                      color="blue"
                                      text-color="white"
                                      style="font-size: 9px; height: 18px;">
                                      {{ getMurniInfo() }}
                                    </v-chip>
                                  </div>
    
                                  <div
                                    class="text-h5 black--text"
                                    style="font-weight: 500;">
                                    <span v-if="getTotalSubKegiatan('murni') === '-'">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ getTotalSubKegiatan('murni') | number }}
                                    </span>
                                  </div>
                                </div>
    
                                <div class="boder-margin-4">
                                  <div class="d-flex align-center mb-1">
                                    <div style="font-weight: 500; color: #FF9800;">
                                      P1
                                    </div>
                                    <v-spacer />
                                    <v-chip
                                      x-small
                                      color="orange"
                                      text-color="white"
                                      style="font-size: 9px; height: 18px;">
                                      {{ getP1Info() }}
                                    </v-chip>
                                  </div>
                                  
                                  <div
                                    class="text-h5 black--text"
                                    style="font-weight: 500;">
                                    <span v-if="getTotalSubKegiatan('p1') === '-'">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ getTotalSubKegiatan('p1') | number }}
                                    </span>
                                  </div>
                                </div>
    
                                <div>
                                  <div class="d-flex align-center mb-1">
                                    <div style="font-weight: 500; color: #4CAF50;">
                                      Perubahan
                                    </div>
                                    <v-spacer />
                                    <v-chip
                                      x-small
                                      color="green"
                                      text-color="white"
                                      style="font-size: 9px; height: 18px;">
                                      {{ getPerubahanInfo() }}
                                    </v-chip>
                                  </div>
    
                                  <div
                                    class="text-h5 black--text"
                                    style="font-weight: 500;">
                                    <span v-if="getTotalSubKegiatan('perubahan') === '-'">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ getTotalSubKegiatan('perubahan') | number }}
                                    </span>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-skeleton-loader>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>

                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
import { get, post, put, patch, destroy } from "@/service/Axios";
// import { filter } from "core-js/core/array";
  export default {
    data() {
      return {
        dialog: {
          warning: false
        },
        clock: {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          time: ''
        },
        getMonth: new Date().getMonth(),

        type: ['Asisten', 'Sekda', 'Dinas Pendidikan', 'Kecamatan', 'Dinas Kesehatan', 'Semua Kecamatan', 'Semua Kelurahan', 'Semua Puskesmas'],

        category: ['OPD', 'Gabungan'],

        asistensi: ['Asisten Administrasi Umum', 'Asisten Perekonomian dan Pembangunan', 'Asisten Pemerintahan dan Kesejahteraan Rakyat'],

        filter: {
          tahun_anggaran: new Date().getFullYear(),
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          month_text: new Date().toLocaleString('id', { month: 'long' }),
          unit_id: '',
          unit_title: '',
          unit_type: '',
          asistensi: '',
          kecamatan_id: '',
          kecamatan_title: '',
          type: '',
          category: '',
          is_pengecualian: '1',
          dpa: 'murni'
        },
        filter_data: {
          unit: [],
          kecamatan: [
            {
              name: 'KECAMATAN KLATEN TENGAH',
              id: '42,326,327,328,330,329,325'
            },
            {
              name: 'KECAMATAN KLATEN UTARA',
              id: '43,334,335'
            },
            {
              name: 'KECAMATAN KLATEN SELATAN',
              id: '41,313'
            },
            {
              name: 'KECAMATAN JATINOM',
              id: '32,179'
            }
          ]
        },
        bulan: [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ],
        unit: [],
        detail: {},
        detailPerubahan: {},
        detailP1: {},

        list: {
          data: [],
          summary: {},
          realisasi: {},
          deviasi: {},
          realisasiP1: {},
          deviasiP1: {},

          count: [
            {
              name: 'Total Anggaran',
              total: 0,
              icon: require('@/assets/icon/budget.png'),
              sub: []
            },
            {
              name: 'Realisasi Keuangan',
              total: 0,
              icon: require('@/assets/icon/dash_kegiatan.png'),
              sub: []
            },
            {
              name: 'Deviasi',
              total: 0,
              icon: require('@/assets/icon/percent.png'),
              sub: []
            },
            {
              name: 'Rata-Rata Target Fisik',
              total: 0,
              icon: require('@/assets/icon/average_target_fisik_format.png'),
              sub: []
            },
            {
              name: 'Persentase Anggaran SP2D',
              total: 0,
              icon: require('@/assets/icon/total_persentase_sp2d.png'),
              sub: []
            },
            {
              name: 'Persentase SP2D',
              total: 0,
              icon: require('@/assets/icon/total_persentase_sp2d_anggaran.png'),
              sub: []
            }
          ],

          program: [],

          persentase: {
            name: 'Persentase Pekerjaan',
            icon: require('@/assets/icon/dash_persen.png'),
            pie: {
              series: [44, 55, 13, 43, 22],
              chartOptions: {
                chart: {
                  width: 380,
                  type: 'pie',
                },
                labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      position: 'bottom'
                    }
                  }
                }]
              }
            }
          },
          dataPerubahan: [],
          realisasiPerubahan: {},
          deviasiPerubahan: {},
        },
        
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    watch: {
      'filter.type': function () {
        let t = this
        t.filter.asistensi = ''
        t.filter.unit_id = ''
        t.filter.kecamatan_id = ''
        if (t.filter.type === 'Asisten' || t.filter.type === 'Kacamatan') {
          // t.filter.asistensi = 'Asisten Administrasi Umum'
        } else {
          this.fetch()
        }
      },

      'filter.asistensi': function () {
        let t = this

        t.filter.asistensi === null ? t.filter.asistensi = '' : ''

        // let u = this.filter_data.unit.filter(function(v) {
        //   return t.filter.unit_id == v.id
        // })

        // if (u.length > 0) {
        //   this.filter.unit_title = u[0].title
        // }
        this.fetch()
      },

      'filter.is_pengecualian': function () {
        let t = this

        t.filter.is_pengecualian === null ? t.filter.is_pengecualian = '' : ''

        // let u = this.filter_data.unit.filter(function(v) {
        //   return t.filter.unit_id == v.id
        // })

        // if (u.length > 0) {
        //   this.filter.unit_title = u[0].title
        // }
        this.fetch()
      },

      'filter.unit_id': function () {
        let t = this

        t.filter.unit_id === null ? t.filter.unit_id = '' : ''

        let u = this.filter_data.unit.filter(function(v) {
          return t.filter.unit_id == v.id
        })

        if (u.length > 0) {
          this.filter.unit_title = u[0].title
          this.filter.unit_type = u[0].type
        }
        this.fetch()
      },

      'filter.kecamatan_id': function () {
        let t = this

        t.filter.kecamatan_id === null ? t.filter.kecamatan_id = '' : ''

        let u = this.filter_data.kecamatan.filter(function(v) {
          return t.filter.kecamatan_id == v.id
        })

        if (u.length > 0) {
          this.filter.kecamatan_title = u[0].name
        }
        this.fetch()
      },
      'filter.year': function () {
        this.fetchDpa()
      },
      'filter.month': function () {
        this.filter.month_text = ''
        this.bulan.map((v, i) => {
          if (v.value === this.filter.month) {
            this.filter.month_text = v.text
          }
        })
        this.fetch()
      },
      'filter.dpa': function () {
        this.fetch()
      },
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      dpa () {
        return this.$store.state.dpa
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        this.filter.year = this.$store.state.year

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        
        this.filter.month = numb

        this.filter.month_text = new Date().toLocaleString('id', { month: 'long' })

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      },
      // Computed untuk menentukan periode DPA
      dpaPeriods () {
        if (!this.dpa || !this.dpa.tahun) return null
        
        const murniDate = this.dpa.murni_date ? new Date(this.dpa.murni_date) : null
        const p1Date = this.dpa.p1_date ? new Date(this.dpa.p1_date) : null
        const perubahanDate = this.dpa.perubahan_date ? new Date(this.dpa.perubahan_date) : null
        
        return {
          murniStart: murniDate,
          murniEnd: p1Date || perubahanDate,
          p1Start: p1Date,
          p1End: perubahanDate,
          perubahanStart: perubahanDate
        }
      },
      // Menentukan bulan terakhir untuk setiap periode
      lastMurniMonth () {
        if (!this.dpaPeriods || !this.dpaPeriods.murniEnd) return null
        // Bulan terakhir murni adalah bulan sebelum murniEnd
        // Jika murniEnd adalah April (bulan 3, 0-based), maka bulan terakhir murni adalah Maret (bulan 2, 0-based)
        const endMonth = this.dpaPeriods.murniEnd.getMonth()
        return endMonth > 0 ? endMonth - 1 : 11 // Jika bulan 0 (Januari), kembali ke Desember (bulan 11)
      },
      lastP1Month () {
        if (!this.dpaPeriods || !this.dpaPeriods.p1End) return null
        // Bulan terakhir P1 adalah bulan sebelum p1End
        const endMonth = this.dpaPeriods.p1End.getMonth()
        return endMonth > 0 ? endMonth - 1 : 11 // Jika bulan 0 (Januari), kembali ke Desember (bulan 11)
      },
      // Menentukan apakah bulan yang dipilih dalam periode tertentu
      isInMurniPeriod () {
        if (!this.dpaPeriods || !this.dpaPeriods.murniStart) return false
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const murniStart = new Date(this.dpaPeriods.murniStart.getFullYear(), this.dpaPeriods.murniStart.getMonth(), 1)
        const murniEnd = this.dpaPeriods.murniEnd ? new Date(this.dpaPeriods.murniEnd.getFullYear(), this.dpaPeriods.murniEnd.getMonth(), 1) : null
        
        return selectedDate >= murniStart && (!murniEnd || selectedDate < murniEnd)
      },
      isInP1Period () {
        if (!this.dpaPeriods || !this.dpaPeriods.p1Start) return false
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const p1Start = new Date(this.dpaPeriods.p1Start.getFullYear(), this.dpaPeriods.p1Start.getMonth(), 1)
        const p1End = this.dpaPeriods.p1End ? new Date(this.dpaPeriods.p1End.getFullYear(), this.dpaPeriods.p1End.getMonth(), 1) : null
        
        return selectedDate >= p1Start && (!p1End || selectedDate < p1End)
      },
      isInPerubahanPeriod () {
        if (!this.dpaPeriods || !this.dpaPeriods.perubahanStart) return false
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const perubahanStart = new Date(this.dpaPeriods.perubahanStart.getFullYear(), this.dpaPeriods.perubahanStart.getMonth(), 1)
        
        return selectedDate >= perubahanStart
      }
    },
    mounted () {
      setInterval(this.updateTime, 1000)
      
      this.fetchDpa()
      // this.fetch()

      this.fetchUnit()
    },
    methods: {
      async fetchDpa () {
        let params = {
          tahun:  this.filter.year
        }
        await get('admin/dpa/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {

            TokenService.saveDpa(JSON.stringify(res.results.data[0]))

            this.$store.commit("setDpa", res.results.data[0])
            this.fetch()
            
          }
        })
      },
      async fetchUnit () {
        let params = {
          limit: 100000,
          year: new Date().getFullYear()
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
          }
        })
      },
      async fetch () {
        this.process.load = true

        // Tentukan bulan yang tepat untuk fetch data murni
        const murniMonth = this.getMurniMonthForFetch()
        if (murniMonth === null) {
          // Jika tidak ada data murni, set default dan lanjutkan
          this.detail = {}
          this.fetchRealisasi()
          return
        }

        let params = {
          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: murniMonth,
          dpa_status: 'murni'
        }

        await get('admin/dashboard/data', { params })
        .then(response => {
          let res = response.data
            
          // this.process.load = false

          if (res.status === 200) {
            // console.log(this.dpa)
            
            let data = res.results
            if(new Date() < new Date(this.dpa.perubahan_date) === true) {
              if(this.$store.state.user.role === 'opd' && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }

              if(this.$store.state.user.role === 'admin' && (this.filter.unit_id !== '' && this.filter.unit_id !== null) && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }
            }
            
            this.list.data = data.data
            this.detail = data
            this.fetchRealisasi()
          }
        })
      },

      async fetchRealisasi () {
        this.process.load = true

        // Tentukan bulan yang tepat untuk fetch data murni
        const murniMonth = this.getMurniMonthForFetch()
        if (murniMonth === null) {
          this.fetchP1()
          return
        }

        let params = {
          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: murniMonth,
          dpa_status: 'murni'
        }

        await get('admin/dashboard/sub_kegiatan_group', { params })
        .then(response => {
          let res = response.data
            
          // this.process.load = false

          if (res.status === 200) {
            
            let data = res.results

            this.list.realisasi = data.realisasi_fisik
            this.list.deviasi = data.deviasi
            this.fetchP1()
            // this.detail = data
          }
        })
      },

      async fetchP1 () {
        this.process.load = true

        // Tentukan bulan yang tepat untuk fetch data P1
        const p1Month = this.getP1MonthForFetch()
        if (p1Month === null) {
          // Jika tidak ada data P1, set default dan lanjutkan
          this.detailP1 = {}
          this.fetchRealisasiP1()
          return
        }

        let params = {
          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: p1Month,
          dpa_status: 'p1'
        }

        await get('admin/dashboard/data', { params })
        .then(response => {
          let res = response.data
            
          // this.process.load = false

          if (res.status === 200) {
            // console.log(this.dpa)
            
            let data = res.results
            if(new Date() < new Date(this.dpa.perubahan_date) === true) {
              if(this.$store.state.user.role === 'opd' && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }

              if(this.$store.state.user.role === 'admin' && (this.filter.unit_id !== '' && this.filter.unit_id !== null) && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }
            }
            
            this.list.data = data.data
            this.detailP1 = data
            this.fetchRealisasiP1()
          }
        })
      },

      async fetchRealisasiP1 () {
        this.process.load = true

        // Tentukan bulan yang tepat untuk fetch data P1
        const p1Month = this.getP1MonthForFetch()
        if (p1Month === null) {
          this.fetchPerubahan()
          return
        }

        let params = {
          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: p1Month,
          dpa_status: 'p1'
        }

        await get('admin/dashboard/sub_kegiatan_group', { params })
        .then(response => {
          let res = response.data
            
          // this.process.load = false

          if (res.status === 200) {
            
            let data = res.results

            this.list.realisasiP1 = data.realisasi_fisik
            this.list.deviasiP1 = data.deviasi
            console.log(this.filter.year, this.filter.month)
            if(this.filter.year === 2025 && (this.filter.month === 4 || this.filter.month === 5 || this.filter.month === 6 || this.filter.month === 7)) {
              console.log('masuk')
              this.list.realisasi = data.realisasi_fisik
              this.list.deviasi = data.deviasi
            }
            this.fetchPerubahan()
            // this.detail = data
          }
        })
      },

      async fetchPerubahan () {
        this.process.load = true

        // Tentukan bulan yang tepat untuk fetch data perubahan
        const perubahanMonth = this.getPerubahanMonthForFetch()
        if (perubahanMonth === null) {
          // Jika tidak ada data perubahan, set default dan lanjutkan
          this.detailPerubahan = {}
          this.fetchRealisasiPerubahan()
          return
        }

        let params = {

          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: perubahanMonth,
          dpa_status: 'perubahan'
        }

        await get('admin/dashboard/data', { params })
        .then(response => {
          let res = response.data
            
          // this.process.load = false

          if (res.status === 200) {
            
            let data = res.results
            if(new Date() < new Date(this.dpa.perubahan_date) === false) {
              if(this.$store.state.user.role === 'opd' && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }
  
              if(this.$store.state.user.role === 'admin' && (this.filter.unit_id !== '' && this.filter.unit_id !== null) && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }
            }
            
            this.list.dataPerubahan = data.data
            this.detailPerubahan = data
            this.fetchRealisasiPerubahan()
          }
        })
      },

      async fetchRealisasiPerubahan () {
        this.process.load = true

        // Tentukan bulan yang tepat untuk fetch data perubahan
        const perubahanMonth = this.getPerubahanMonthForFetch()
        if (perubahanMonth === null) {
          this.process.load = false
          return
        }

        let params = {

          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: perubahanMonth,
          dpa_status: 'perubahan'
        }

        await get('admin/dashboard/sub_kegiatan_group', { params })
        .then(response => {
          let res = response.data
            
          this.process.load = false

          if (res.status === 200) {
            
            let data = res.results

            this.list.realisasiPerubahan = data.realisasi_fisik
            this.list.deviasiPerubahan = data.deviasi
            if(this.filter.year === 2025 && (this.filter === 4 || this.filter === 5 || this.filter === 6 || this.filter === 7)) {
              // this.list.realisasi = data.realisasi_fisik
              // this.list.deviasi = data.deviasi
            } else {
            if(new Date(this.filter.year, this.filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) === false) {
                this.list.realisasi = data.realisasi_fisik
                this.list.deviasi = data.deviasi
              }
            }
            // this.detail = data
          }
        })
      },

      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      },
      // Helper methods untuk mendapatkan nilai berdasarkan periode
      getMurniValue (field) {
        // Jika bulan yang dipilih sebelum periode murni dimulai
        if (!this.dpaPeriods || !this.dpaPeriods.murniStart) {
          return '-'
        }
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const murniStart = new Date(this.dpaPeriods.murniStart.getFullYear(), this.dpaPeriods.murniStart.getMonth(), 1)
        
        if (selectedDate < murniStart) {
          return '-'
        }
        
        // Jika dalam periode murni, tampilkan data bulan tersebut
        if (this.isInMurniPeriod) {
          return this.detail[field] || 0
        }
        
        // Jika tidak dalam periode murni (sudah masuk P1 atau Perubahan), 
        // tampilkan data dari bulan terakhir murni
        // Kita perlu mengambil data dari bulan terakhir murni, bukan bulan yang dipilih
        // Untuk sekarang, kita akan menggunakan data dari detail (yang seharusnya sudah sesuai)
        return this.detail[field] || 0
      },
      getP1Value (field) {
        // Jika bulan yang dipilih sebelum periode P1 dimulai atau P1 tidak ada
        if (!this.dpaPeriods || !this.dpaPeriods.p1Start) {
          return '-'
        }
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const p1Start = new Date(this.dpaPeriods.p1Start.getFullYear(), this.dpaPeriods.p1Start.getMonth(), 1)
        
        if (selectedDate < p1Start) {
          return '-'
        }
        
        // Jika dalam periode P1, tampilkan data bulan tersebut
        if (this.isInP1Period) {
          return this.detailP1[field] || 0
        }
        
        // Jika dalam periode perubahan, tampilkan data dari bulan terakhir P1
        if (this.isInPerubahanPeriod) {
          return this.detailP1[field] || 0
        }
        
        return this.detailP1[field] || 0
      },
      getPerubahanValue (field) {
        // Jika bulan yang dipilih sebelum periode perubahan dimulai atau perubahan tidak ada
        if (!this.dpaPeriods || !this.dpaPeriods.perubahanStart) {
          return '-'
        }
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const perubahanStart = new Date(this.dpaPeriods.perubahanStart.getFullYear(), this.dpaPeriods.perubahanStart.getMonth(), 1)
        
        if (selectedDate < perubahanStart) {
          return '-'
        }
        
        // Jika dalam periode perubahan, tampilkan data bulan tersebut
        return this.detailPerubahan[field] || 0
      },
      // Helper untuk mendapatkan bulan yang tepat untuk fetch data
      getMurniMonthForFetch () {
        if (!this.dpaPeriods || !this.dpaPeriods.murniStart) {
          return this.filter.month
        }
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const murniStart = new Date(this.dpaPeriods.murniStart.getFullYear(), this.dpaPeriods.murniStart.getMonth(), 1)
        
        if (selectedDate < murniStart) {
          return null // Tidak ada data
        }
        
        // Jika dalam periode murni, gunakan bulan yang dipilih
        if (this.isInMurniPeriod) {
          return this.filter.month
        }
        
        // Jika tidak dalam periode murni, gunakan bulan terakhir murni
        // lastMurniMonth sudah dalam format 0-based, jadi perlu +1 untuk mendapatkan bulan 1-based
        if (this.lastMurniMonth !== null) {
          const lastMonth = this.lastMurniMonth + 1
          console.log('Bulan terakhir murni:', lastMonth, 'dari p1Date:', this.dpaPeriods.p1Start)
          return lastMonth
        }
        
        return this.filter.month
      },
      getP1MonthForFetch () {
        if (!this.dpaPeriods || !this.dpaPeriods.p1Start) {
          return null
        }
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const p1Start = new Date(this.dpaPeriods.p1Start.getFullYear(), this.dpaPeriods.p1Start.getMonth(), 1)
        
        if (selectedDate < p1Start) {
          return null // Belum masuk periode P1
        }
        
        // Jika dalam periode P1, gunakan bulan yang dipilih
        if (this.isInP1Period) {
          return this.filter.month
        }
        
        // Jika dalam periode perubahan, gunakan bulan terakhir P1
        if (this.isInPerubahanPeriod && this.lastP1Month !== null) {
          return this.lastP1Month + 1 // +1 karena getMonth() return 0-based
        }
        
        return this.filter.month
      },
      getPerubahanMonthForFetch () {
        if (!this.dpaPeriods || !this.dpaPeriods.perubahanStart) {
          return null
        }
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const perubahanStart = new Date(this.dpaPeriods.perubahanStart.getFullYear(), this.dpaPeriods.perubahanStart.getMonth(), 1)
        
        if (selectedDate < perubahanStart) {
          return null // Belum masuk periode perubahan
        }
        
        // Jika dalam periode perubahan, gunakan bulan yang dipilih
        return this.filter.month
      },
      // Helper untuk mendapatkan keterangan bulan
      getMurniInfo () {
        if (!this.dpaPeriods || !this.dpaPeriods.murniStart) {
          return 'Data belum tersedia'
        }
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const murniStart = new Date(this.dpaPeriods.murniStart.getFullYear(), this.dpaPeriods.murniStart.getMonth(), 1)
        
        if (selectedDate < murniStart) {
          return 'Data belum tersedia'
        }
        
        if (this.isInMurniPeriod) {
          return `Bulan ${this.filter.month_text} ${this.filter.year}`
        }
        
        // Jika tidak dalam periode murni, tampilkan bulan terakhir murni
        if (this.lastMurniMonth !== null) {
          const monthNames = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
          return `Bulan terakhir: ${monthNames[this.lastMurniMonth]} ${this.filter.year}`
        }
        
        return `Bulan ${this.filter.month_text} ${this.filter.year}`
      },
      getP1Info () {
        if (!this.dpaPeriods || !this.dpaPeriods.p1Start) {
          return 'Data belum tersedia'
        }
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const p1Start = new Date(this.dpaPeriods.p1Start.getFullYear(), this.dpaPeriods.p1Start.getMonth(), 1)
        
        if (selectedDate < p1Start) {
          return 'Data belum tersedia'
        }
        
        if (this.isInP1Period) {
          return `Bulan ${this.filter.month_text} ${this.filter.year}`
        }
        
        // Jika dalam periode perubahan, tampilkan bulan terakhir P1
        if (this.isInPerubahanPeriod && this.lastP1Month !== null) {
          const monthNames = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
          return `Bulan terakhir: ${monthNames[this.lastP1Month]} ${this.filter.year}`
        }
        
        return `Bulan ${this.filter.month_text} ${this.filter.year}`
      },
      getPerubahanInfo () {
        if (!this.dpaPeriods || !this.dpaPeriods.perubahanStart) {
          return 'Data belum tersedia'
        }
        const selectedDate = new Date(this.filter.year, this.filter.month - 1, 1)
        const perubahanStart = new Date(this.dpaPeriods.perubahanStart.getFullYear(), this.dpaPeriods.perubahanStart.getMonth(), 1)
        
        if (selectedDate < perubahanStart) {
          return 'Data belum tersedia'
        }
        
        return `Bulan ${this.filter.month_text} ${this.filter.year}`
      },
      // Helper untuk mendapatkan nilai persentase berdasarkan periode
      getPersentasePaguAnggaran () {
        if (this.isInMurniPeriod) {
          return this.detail.sp2d_pagu_anggaran || 0
        }
        if (this.isInP1Period) {
          return this.detailP1.sp2d_pagu_anggaran || 0
        }
        if (this.isInPerubahanPeriod) {
          return this.detailPerubahan.sp2d_pagu_anggaran || 0
        }
        return 0
      },
      getPersentaseAnggaranKas () {
        if (this.isInMurniPeriod) {
          return this.detail.sp2d_anggaran || 0
        }
        if (this.isInP1Period) {
          return this.detailP1.sp2d_anggaran || 0
        }
        if (this.isInPerubahanPeriod) {
          return this.detailPerubahan.sp2d_anggaran || 0
        }
        return 0
      },
      // Helper untuk mendapatkan nilai Realisasi Keuangan berdasarkan periode
      getSp2dBulan () {
        if (this.isInMurniPeriod) {
          return this.detail.sp2d_bulan || 0
        }
        if (this.isInP1Period) {
          return this.detailP1.sp2d_bulan || 0
        }
        if (this.isInPerubahanPeriod) {
          return this.detailPerubahan.sp2d_bulan || 0
        }
        return 0
      },
      getSp2bBulan () {
        if (this.isInMurniPeriod) {
          return this.detail.sp2b_bulan || 0
        }
        if (this.isInP1Period) {
          return this.detailP1.sp2b_bulan || 0
        }
        if (this.isInPerubahanPeriod) {
          return this.detailPerubahan.sp2b_bulan || 0
        }
        return 0
      },
      getRealisasiKeuangan () {
        if (this.isInMurniPeriod) {
          return this.detail.realisasi_keuangan || 0
        }
        if (this.isInP1Period) {
          return this.detailP1.realisasi_keuangan || 0
        }
        if (this.isInPerubahanPeriod) {
          return this.detailPerubahan.realisasi_keuangan || 0
        }
        return 0
      },
      getTotalSp2bSp2d () {
        return (this.getSp2bBulan() * 1) + (this.getSp2dBulan() * 1)
      },
      getSelisihRealisasi () {
        return (this.getRealisasiKeuangan() * 1) - this.getTotalSp2bSp2d()
      },
      // Helper untuk mendapatkan nilai Program, Kegiatan, Sub Kegiatan berdasarkan periode
      getTotalProgram (period) {
        if (period === 'murni') {
          const value = this.getMurniValue('total_program')
          return value === '-' ? '-' : (value || 0)
        }
        if (period === 'p1') {
          const value = this.getP1Value('total_program')
          return value === '-' ? '-' : (value || 0)
        }
        if (period === 'perubahan') {
          const value = this.getPerubahanValue('total_program')
          return value === '-' ? '-' : (value || 0)
        }
        return '-'
      },
      getTotalKegiatan (period) {
        if (period === 'murni') {
          const value = this.getMurniValue('total_kegiatan')
          return value === '-' ? '-' : (value || 0)
        }
        if (period === 'p1') {
          const value = this.getP1Value('total_kegiatan')
          return value === '-' ? '-' : (value || 0)
        }
        if (period === 'perubahan') {
          const value = this.getPerubahanValue('total_kegiatan')
          return value === '-' ? '-' : (value || 0)
        }
        return '-'
      },
      getTotalSubKegiatan (period) {
        if (period === 'murni') {
          const value = this.getMurniValue('total_sub_kegiatan')
          return value === '-' ? '-' : (value || 0)
        }
        if (period === 'p1') {
          const value = this.getP1Value('total_sub_kegiatan')
          return value === '-' ? '-' : (value || 0)
        }
        if (period === 'perubahan') {
          const value = this.getPerubahanValue('total_sub_kegiatan')
          return value === '-' ? '-' : (value || 0)
        }
        return '-'
      }
    }
  }
</script>

<style scoped>
  table, th, td {
    border-spacing: 4px;
    border-collapse: collapse;
  }
  .grafik_loader .v-skeleton-loader {
    min-height: 350px !important;
  }

  .grafik_loader .v-skeleton-loader .v-skeleton-loader__image {
    height: 350px !important;
  }

  .text-center {
    background: white !important;
  }

  /* ===== CLEAN CARD DESIGN ===== */
  .border-radius {
    border-radius: 12px !important;
    transition: all 0.2s ease !important;
    overflow: hidden;
    position: relative;
    background: #FFFFFF !important;
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
  }

  .border-radius:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
    border-color: rgba(0, 0, 0, 0.12) !important;
  }

  /* ===== CLEAN STAT CARD ===== */
  .stat-card {
    background: #FFFFFF !important;
    position: relative;
    overflow: visible;
  }

  /* ===== CLEAN VALUE DISPLAY ===== */
  .value-display {
    font-weight: 600 !important;
    font-size: 20px !important;
    color: #1a1a1a !important;
    letter-spacing: -0.3px;
    line-height: 1.4;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
  }

  /* ===== CLEAN PERIOD BADGE ===== */
  .period-badge {
    border-radius: 6px !important;
    font-weight: 500 !important;
    text-transform: none;
    letter-spacing: 0.1px;
    font-size: 10px !important;
    padding: 4px 10px !important;
    box-shadow: none !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    height: auto !important;
    min-height: 20px !important;
  }

  /* ===== CLEAN PERIOD LABEL ===== */
  .period-label {
    font-weight: 600 !important;
    font-size: 12px !important;
    text-transform: none;
    letter-spacing: 0.2px;
    position: relative;
    padding-left: 12px;
  }

  .period-label::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 14px;
    border-radius: 2px;
  }

  .period-label.murni {
    color: #1976D2 !important;
  }

  .period-label.murni::before {
    background: #1976D2;
  }

  .period-label.p1 {
    color: #FF9800 !important;
  }

  .period-label.p1::before {
    background: #FF9800;
  }

  .period-label.perubahan {
    color: #4CAF50 !important;
  }

  .period-label.perubahan::before {
    background: #4CAF50;
  }

  /* ===== CLEAN ICON CONTAINER ===== */
  .icon-container {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.03);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
  }

  .border-radius:hover .icon-container {
    background: rgba(0, 0, 0, 0.05);
  }

  /* ===== CLEAN TABLE ===== */
  table {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: #ffffff;
  }

  table tr {
    transition: background-color 0.15s ease;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  table tr:last-child {
    border-bottom: none;
  }

  table tr:hover {
    background: rgba(0, 0, 0, 0.02) !important;
  }

  table th {
    background: rgba(0, 0, 0, 0.03) !important;
    color: rgba(0, 0, 0, 0.8) !important;
    font-weight: 600 !important;
    letter-spacing: 0.2px;
    text-transform: none;
    font-size: 12px !important;
    padding: 12px 16px !important;
  }

  table td {
    padding: 12px 16px !important;
    vertical-align: middle;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 400;
  }

  /* ===== CLEAN CARD TITLE ===== */
  .card-title-enhanced {
    font-weight: 600 !important;
    font-size: 15px !important;
    letter-spacing: -0.2px;
    color: #1a1a1a !important;
    line-height: 1.4;
  }

  /* ===== CLEAN SUBTITLE ===== */
  .card-subtitle-enhanced {
    font-size: 12px !important;
    font-weight: 400 !important;
    color: rgba(0, 0, 0, 0.6) !important;
    letter-spacing: 0.1px;
    margin-top: 4px;
  }

  /* ===== CLEAN DIVIDER ===== */
  .v-divider {
    border-color: rgba(0, 0, 0, 0.08) !important;
    border-width: 1px !important;
  }

  /* ===== CLEAN NUMBER DISPLAY ===== */
  .number-display {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', Roboto, sans-serif;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 1.3;
  }

  /* ===== CLEAN EMPTY STATE ===== */
  .empty-state {
    color: rgba(0, 0, 0, 0.35);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
  }

  /* ===== CLEAN PERIOD VALUE CONTAINERS ===== */
  .boder-margin-4 {
    position: relative;
    padding: 16px 0;
    /* margin-bottom: 24px !important; */
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .boder-margin-4:last-child {
    margin-bottom: 0 !important;
    border-bottom: none;
    padding-bottom: 0;
  }

  /* ===== FIX COLUMN SPACING ===== */
  .v-row.mx-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .v-col.px-3 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  /* ===== FIX PERKEMBANGAN FISIK LAYOUT ===== */
  .v-card__text.py-0 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }

  /* ===== FIX OVERLAP ISSUES ===== */
  .v-card__text + .v-card__text {
    padding-top: 0 !important;
  }

  /* ===== ENSURE PROPER SPACING IN COLUMNS ===== */
  .v-col .boder-margin-4 {
    min-height: 60px;
  }

  /* ===== FIX TEXT OVERFLOW ===== */
  .caption {
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.4;
  }

  /* ===== PERIOD ROW STYLING ===== */
  .period-row {
    padding-bottom: 12px;
    margin-bottom: 12px !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .period-row:last-child {
    border-bottom: none;
    margin-bottom: 0 !important;
    padding-bottom: 0;
  }

  /* ===== PERKEMBANGAN FISIK COLUMN HEADER ===== */
  .v-col .mb-3 {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #1a1a1a;
    margin-bottom: 20px !important;
    padding-bottom: 12px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  }

  /* ===== RESPONSIVE DESIGN ===== */
  @media (max-width: 960px) {
    .border-radius {
      margin-bottom: 16px;
      border-radius: 12px !important;
    }
    
    .border-radius:hover {
      transform: none;
    }

    .value-display {
      font-size: 18px !important;
    }

    .card-title-enhanced {
      font-size: 14px !important;
    }

    .icon-container {
      width: 48px;
      height: 48px;
    }

    .v-card__text {
      padding: 16px 20px !important;
    }
  }

  /* ===== CLEAN SCROLLBAR ===== */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.02);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }

  /* ===== CLEAN CARD PADDING ===== */
  .v-card {
    overflow: visible !important;
  }

  .v-card__text {
    padding: 12px 14px !important;
  }

  .v-card__text:first-child {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  /* ===== CLEAN PERIOD SECTION ===== */
  .mb-1 {
    margin-bottom: 10px !important;
    padding-bottom: 0;
  }

  .text-h5 {
    margin-top: 6px !important;
    line-height: 1.4 !important;
  }

  /* ===== CLEAN TYPOGRAPHY ===== */
  .body-2 strong {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }

  /* ===== CLEAN CHIP ===== */
  .v-chip {
    font-weight: 500 !important;
    height: 20px !important;
    font-size: 9px !important;
    border-radius: 4px !important;
  }

  /* ===== RESPONSIVE SPACING ===== */
  @media (max-width: 960px) {
    .v-card__text {
      padding: 16px 20px !important;
    }

    .v-card__text:first-child {
      padding-top: 20px !important;
      padding-bottom: 16px !important;
    }
  }
</style>